import { Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import moment from "moment";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

// import { getLogisticStopsData } from "../../actions/LogisticsPanelAction";
// import { generateStopsFilter } from "../../../helpers/generateUrl";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },
        contentHeader: {
            width: "100%",
            padding: "0px 10px 40px 10px",
            minHeight: "64px",
        },
        leftContentHeader: {
            width: "50%",
            float: "left",
        },
        rightContentHeader: {
            width: "50%",
            float: "right",
            textAlign: "right",
            paddingRight: "20px",
        },
        buttonContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        head: {
            textAlign: "center",
            fontWeight: "normal",
            marginBottom: "2rem",
        },
        slotContainer: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
        },
        slot: {
            width: "150px",
            height: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            margin: "0.5rem",
        },
        hoveItem: {
            cursor: "pointer",
        },
        selectedSlot: {
            width: "150px",
            height: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
            cursor: "pointer",
            margin: "0.5rem",
        },
        chips: {
            display: "flex",
        },
        chip: {
            margin: 2,
            background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
            maxWidth: "130px",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        }
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    getCities: any;
    cities: any;
    loading: any;
}
const StopsPlace: React.FC<Props> = ({
    getCities,
    cities,
    loading,
}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [index, setIndex] = useState<any>("none");
    const [freezerName, setFreezerName] = useState<any>("");
    const [boxID, setBoxID] = useState<any>("");
    const [wellID, setWellID] = useState<any>("");
    const [indexID, setIndexId] = useState<any>("none");
    const [indexID2, setIndexId2] = useState<any>("none");
    const [librarySize, setLibrarySize] = useState<any>("");
    const [libraryQC, setLibraryQC] = useState<any>("");
    const [requirement, setRequiredment] = useState<any>([]);
    const [insertSize, setInsertSize] = useState<any>("");
    const [libType, setLibType] = useState<any>("")
    const [isEdit, setIsEdit] = useState<any>(false);
    const [libraryDate, setLibrarydate] = useState<any>("");
    const [libraryKit, setLibraryKit] = useState<any>("");
    const [page, setPage] = useState(0);
    const [project, setProject] = useState<any>("none");
    const [chemistry, setChemistry] = useState<any>("");
    const [libID, setLibId] = useState<any>("");
    const { id } = useParams<{ id: string }>();
    const [docEmail, setDocEmail] = useState<any>([]);
    const [libConcentration, setLibConcentration] = useState<any>("");
    const [libraryStatus, setLibraryStatus] = useState<any>("1");
    const [subProject, setSubProject] = useState<any>("nones");
    const [sampleId, setSampleID] = useState<any>("1");
    const [file1, setFile1] = React.useState<any>([]);
    const [file2, setFile2] = React.useState<any>([]);
    const [indexType, setIndexType] = useState<any>("none");
    const [indexSeq, setIndexSeq] = useState<any>("none");
    const [indexSeq2, setIndexSeq2] = useState<any>("none")
    const fileSelectedHandler1 = (e: React.ChangeEvent<{ files: any }>) => {
        setFile1(e.target.files[0]);
    };
    const fileSelectedHandler2 = (e: React.ChangeEvent<{ files: any }>) => {
        setFile2(e.target.files[0]);
    };
    const handleAddSequence = async (e: any) => {
        const arr: any = [...requirement]
        e.preventDefault();
        arr.push({
            project_id: project,
            sub_project_id: subProject,
            sample_id: sampleId,
            library_kit: libraryKit,
            library_id: libID,
            library_status: libraryStatus,
            library_size: librarySize,
            freezer_name: freezerName,
            box_id: boxID,
            well_id: wellID,
            library_concentration: libConcentration,
            library_qc_status: libraryQC,
            index_id: indexID,
            index_type: indexType,
            index1: index,
            index_id2: indexID2,
            lib_type: libType,
            insert_size: insertSize,
            chemistry: chemistry,
            library_date: libraryDate,
            index_seq: indexSeq,
            index_seq2: indexSeq2,
        })
        setRequiredment(arr);
        // history.push("/dashboard/gnrelab/library/create");

    };
    const handleEditCentre = (data: any) => {
        setProject(data?.project_id);
        setSubProject(data?.sub_project_id);
        setSampleID(data?.sample_id);
        setLibId(data?.library_id);
        setLibraryStatus(data?.library_status);
        setLibraryKit(data?.library_kit);
        setLibrarySize(data?.library_size);
        setFreezerName(data?.freezer_name);
        setBoxID(data?.box_id);
        setWellID(data?.well_id);
        setLibConcentration(data?.address);
        setLibraryQC(data?.library_qc_status);
        setIndex(data?.index_id);
        setIndexType(data?.index_type);
        setIndexId(data?.index1);
        setLibType(data?.lib_type);
        setInsertSize(data?.insert_size);
        setChemistry(data?.chemistry);
        setLibrarydate(data?.library_date);
        setIndexSeq(data?.index_seq);
        setIndexSeq2(data?.index_seq2);
    };
    return (
        <Grid container spacing={2}>
            <form onSubmit={handleAddSequence} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "100%" }} className={classes.root1}>
                    <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Fill Library Details</h2>
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={4} md={2} >
                            <Select
                                label="Project Id"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={project}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setProject(e.target.value)}
                            >
                                <MenuItem value="none"> Project ID </MenuItem>
                                <MenuItem value="P1001,Testing"> P1001,Testing </MenuItem>
                                <MenuItem value="P1002,testing2 "> P1002,testing2 </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                label="SubProject Id"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={subProject}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setSubProject(e.target.value)}
                            >
                                <MenuItem value="nones">SubProject Id</MenuItem>
                                <MenuItem value="none"> SP101 </MenuItem>
                                <MenuItem value="none1"> SP102 </MenuItem>
                                <MenuItem value="none1"> SP103 </MenuItem>

                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                label="Sample Name"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={sampleId}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setSampleID(e.target.value)}
                            >
                                <MenuItem value="1" disabled> Sample Name</MenuItem>
                                <MenuItem value="Sample testing1"> Sample testing1 </MenuItem>
                                <MenuItem value="Sample testing2"> Sample testing2 </MenuItem>
                                <MenuItem value="Sample testing3"> Sample testing3 </MenuItem>
                                <MenuItem value="Sample testing4"> Sample testing4 </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Library ID"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={libID}
                                onChange={(e) => setLibId(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Library Kit"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={libraryKit}
                                onChange={(e) => setLibraryKit(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                label="Library QC Status"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={libraryStatus}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setLibraryStatus(e.target.value)}
                            >
                                <MenuItem value="1" disabled> Library Status</MenuItem>
                                <MenuItem value="Pass">Pass </MenuItem>
                                <MenuItem value="Fail"> Fail </MenuItem>
                            </Select>
                        </Grid>
                        {/* <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Library Size"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={librarySize}
                                onChange={(e) => setLibrarySize(e.target.value)}
                            />
                        </Grid> */}

                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Freezer Name"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={freezerName}
                                onChange={(e) => setFreezerName(e.target.value)}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Box ID"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={boxID}
                                onChange={(e) => setBoxID(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Well ID"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={wellID}
                                onChange={(e) => setWellID(e.target.value)}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Library Concentration"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={libConcentration}
                                onChange={(e) => setLibConcentration(e.target.value)}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Library QC Status"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={libraryQC}
                                onChange={(e) => setLibraryQC(e.target.value)}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                label="Index Type"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={indexType}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setIndexType(e.target.value)}
                            >
                                <MenuItem value="none">Index Type</MenuItem>
                                <MenuItem value="Single_Index">Single Index</MenuItem>
                                <MenuItem value="Dual_Index">Dual Index</MenuItem>

                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                label="Index ID"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={index}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setIndex(e.target.value)}
                            >
                                <MenuItem value="none">Index ID</MenuItem>
                                <MenuItem value="R701">R701</MenuItem>
                                <MenuItem value="R702">R702</MenuItem>
                                <MenuItem value="R703">R703</MenuItem>
                                <MenuItem value="R704">R704</MenuItem>
                                <MenuItem value="R705">R705</MenuItem>
                                <MenuItem value="R706">R706</MenuItem>
                                <MenuItem value="R707">R707</MenuItem>
                                <MenuItem value="R708">R708</MenuItem>
                                <MenuItem value="R709">R709</MenuItem>
                                <MenuItem value="R710">R710</MenuItem>

                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                label="Index 1"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={indexID2}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setIndexId2(e.target.value)}
                            >
                                <MenuItem value="none">Index ID 1</MenuItem>
                                <MenuItem value="ATCACG">ATCACG</MenuItem>
                                <MenuItem value="CGATGT">CGATGT</MenuItem>
                                <MenuItem value="TTAGGC">TTAGGC</MenuItem>
                                <MenuItem value="TGACCA">TGACCA</MenuItem>
                                <MenuItem value="ACAGTG">ACAGTG</MenuItem>
                                <MenuItem value="GCCAAT">GCCAAT</MenuItem>
                                <MenuItem value="CAGATC">CAGATC</MenuItem>
                                <MenuItem value="ACTTGA">ACTTGA</MenuItem>
                                <MenuItem value="GATCAG">GATCAG</MenuItem>
                                <MenuItem value="TAGCTT">TAGCTT</MenuItem>

                            </Select>
                        </Grid>
                        {indexType === "Dual_Index" ?
                            <>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Select
                                        label="Index Seq"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={indexSeq}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => setIndexSeq(e.target.value)}
                                    >
                                        <MenuItem value="none">Index Seq</MenuItem>
                                        <MenuItem value="D501">D501</MenuItem>
                                        <MenuItem value="D502">D502</MenuItem>
                                        <MenuItem value="D503">D503</MenuItem>
                                        <MenuItem value="D504">D504</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Select
                                        label="Index Seq 2"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={indexSeq2}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => setIndexSeq2(e.target.value)}
                                    >
                                        <MenuItem value="none">Index Seq 2</MenuItem>
                                        <MenuItem value="TATAGCCT">TATAGCCT</MenuItem>
                                        <MenuItem value="ATAGAGGC">ATAGAGGC</MenuItem>
                                        <MenuItem value="CCTATCCT">CCTATCCT</MenuItem>
                                        <MenuItem value="GGCTCTGA">GGCTCTGA</MenuItem>
                                    </Select>
                                </Grid>
                            </>
                            : ""}
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Lib Type</InputLabel>
                                <Select
                                    label="Lib Type"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={libType}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setLibType(e.target.value)}
                                >
                                    <MenuItem value="Paired End">Paired End</MenuItem>
                                    <MenuItem value="Mate Pair">Mate Pair</MenuItem>
                                    <MenuItem value="CLR">CLR</MenuItem>
                                    <MenuItem value="HiFi">HiFi</MenuItem>
                                    <MenuItem value="HiC">HiC</MenuItem>
                                    <MenuItem value="SE">SE</MenuItem>
                                    <MenuItem value="Others">Others</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Library Size</InputLabel>
                                <Select
                                    label="Library Size"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={insertSize}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setInsertSize(e.target.value)}
                                >
                                    <MenuItem value="250">250</MenuItem>
                                    <MenuItem value="300">300</MenuItem>
                                    <MenuItem value="450">450</MenuItem>
                                    <MenuItem value="550">550</MenuItem>
                                    <MenuItem value="800">800</MenuItem>
                                    <MenuItem value="SE">SE</MenuItem>
                                    <MenuItem value="1kb">1kb</MenuItem>
                                    <MenuItem value="5kb">5kb</MenuItem>
                                    <MenuItem value="7kb">7kb</MenuItem>
                                    <MenuItem value="10kb">10kb</MenuItem>
                                    <MenuItem value="1-2kb">1-2kb (PB)</MenuItem>
                                    <MenuItem value="2-3kb">2-3kb  (PB)</MenuItem>
                                    <MenuItem value="3-6kb">3-6kb  (PB)</MenuItem>
                                    <MenuItem value="5-10kb">5-10kb  (PB)</MenuItem>
                                    <MenuItem value="10kb CLR">10kb CLR</MenuItem>
                                    <MenuItem value="20kb">20kb CLR</MenuItem>
                                    <MenuItem value="Others">Others</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Chemistry"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={chemistry}
                                onChange={(e) => setChemistry(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <TextField
                                    type="date"
                                    fullWidth
                                    variant="outlined"
                                    label="Library Completion Date"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        min: moment().format("YYYY-MM-DDTHH:MM"),
                                    }}
                                    value={libraryDate}
                                    onChange={(e) => setLibrarydate(e.target.value)}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Library QC Report</InputLabel>
                                <sup
                                    style={{
                                        fontSize: "11px",
                                        marginLeft: "15px",
                                        marginTop: "15px",
                                        background: "#fff",
                                        color: "rgba(0, 0, 0, 0.54)",
                                        letterSpacing: "0.00938em",
                                    }}
                                >
                                </sup>
                                <input
                                    className={classes.input}
                                    style={{
                                        width: "100%",
                                        marginTop: "-15px",
                                        padding: "11.5px 14px",
                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                        borderRadius: "5px",
                                    }}
                                    type="file"
                                    name="file"
                                    id="file"
                                    multiple
                                    onChange={fileSelectedHandler2}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                style={{ width: 200, height: 40 }}

                            >
                                Add
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ width: "100%" }}>
                        <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "550px" }}>
                            <Grid item xs={12} sm={4} md={2}>
                                <Button
                                    variant="contained"
                                    style={{ width: 200, height: 40, color: "white", marginLeft: 1100, backgroundColor: "#00695f" }}

                                >
                                    Submit
                                </Button>
                            </Grid>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell align="center">Project ID</StyledTableCell>
                                        <StyledTableCell align="center">Sub Project ID</StyledTableCell>
                                        <StyledTableCell align="center">Sample ID</StyledTableCell>
                                        <StyledTableCell align="center">Lab Id</StyledTableCell>
                                        <StyledTableCell align="center">Library Kit</StyledTableCell>
                                        <StyledTableCell align="center">Library ID</StyledTableCell>
                                        <StyledTableCell align="center">Library QC Status</StyledTableCell>
                                        <StyledTableCell align="center">Library Size</StyledTableCell>
                                        <StyledTableCell align="center">Freezer name</StyledTableCell>
                                        {/* <StyledTableCell align="center">Box ID</StyledTableCell>
                                        <StyledTableCell align="center">Well ID</StyledTableCell> */}
                                        <StyledTableCell align="center">Library Concentration</StyledTableCell>
                                        {/* <StyledTableCell align="center">Library QC Status</StyledTableCell> */}
                                        <StyledTableCell align="center">Index ID Details</StyledTableCell>
                                        <StyledTableCell align="center">Index ID</StyledTableCell>
                                        <StyledTableCell align="center">Index 1</StyledTableCell>
                                        <StyledTableCell align="center">Index Seq</StyledTableCell>
                                        <StyledTableCell align="center">Index Seq 2</StyledTableCell>
                                        <StyledTableCell align="center">Lib Type</StyledTableCell>
                                        <StyledTableCell align="center">Insert Size</StyledTableCell>
                                        <StyledTableCell align="center">Chemistry</StyledTableCell>
                                        <StyledTableCell align="center">Library Completetion Date</StyledTableCell>
                                        <StyledTableCell align="center">Library Qc Report</StyledTableCell>
                                        <StyledTableCell align="center">Edit</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {requirement && requirement.length > 0 && requirement?.map((data: any, index: any) => {
                                        return (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell align="center">{data?.project_id}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.sub_project_id}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.sample_id}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.library_kit}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.library_id}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.library_status}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.library_size}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.freezer_name}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.box_id}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.well_id}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.library_concentration}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.library_qc_status}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.index_id}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.index_type}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.insert_size}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.index1}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.index_id2}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.index_seq}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.index_seq2}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.lib_type}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.chemistry}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.library_date}</StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                    >
                                                        <Edit onClick={() => handleEditCentre(data)} />
                                                    </Button>
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>

                        </TableContainer>
                    </div>
                </Paper>
            </form>
        </Grid >

    );
};
const mapStateToProps = (state: any) => ({

});
export default connect(mapStateToProps, {

})(StopsPlace);
